import { render, staticRenderFns } from "./CbsRevenueWidget.vue?vue&type=template&id=47b45bdf"
import script from "./CbsRevenueWidget.vue?vue&type=script&lang=js"
export * from "./CbsRevenueWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports